import { useEffect, useState } from "react";

export default function Countdown({ target }) {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0, done: false });
  useEffect(() => {
    if (!target) return;
    const tick = () => {
      const diff = new Date(target).getTime() - Date.now();
      if (diff <= 0) return setT({ d: 0, h: 0, m: 0, s: 0, done: true });
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff / 3600000) % 24);
      const m = Math.floor((diff / 60000) % 60);
      const s = Math.floor((diff / 1000) % 60);
      setT({ d, h, m, s, done: false });
    };
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, [target]);

  const Box = ({ v, label }) => (
    <div className="ci-card px-4 py-5 sm:px-6 sm:py-6 min-w-[76px] sm:min-w-[100px] text-center">
      <div className="font-mono font-bold text-3xl sm:text-5xl text-white tabular-nums text-glow-blue">{String(v).padStart(2, "0")}</div>
      <div className="label mt-1">{label}</div>
    </div>
  );

  if (t.done) return <div className="label text-blue-400">O momento chegou</div>;

  return (
    <div data-testid="countdown" className="flex flex-wrap gap-3 sm:gap-4 justify-center">
      <Box v={t.d} label="Dias" />
      <Box v={t.h} label="Horas" />
      <Box v={t.m} label="Min" />
      <Box v={t.s} label="Seg" />
    </div>
  );
}
